import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface LoaderState {
    visible: boolean;
    message: string;
}

@Injectable({ providedIn: 'root' })
export class LoaderService {

    private counter = 0;

    private readonly stateSubject = new BehaviorSubject<LoaderState>({
        visible: false,
        message: 'Cargando...'
    });

    readonly state$ = this.stateSubject.asObservable();

    show(message?: string): void {
        this.counter++;

        if (this.counter === 1) {
            this.stateSubject.next({ visible: true, message: message ?? 'Cargando...' });
        }
    }

    hide(): void {
        if (this.counter <= 0) return;

        this.counter--;
        
        if (this.counter === 0) {
            this.stateSubject.next({ visible: false, message: 'Cargando...' });
        }
    }

    forceHide(): void {
        this.counter = 0;
        this.stateSubject.next({ visible: false, message: 'Cargando...' });
    }
}
